import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Hjemmelsopplysning from './Hjemmelsopplysning.jsx'
import CollapseIcon from '../../../../images/expand copy 3.png'
import ExpandIcon from '../../../../images/collapse copy 3.png'
import PilIcon from '../../../../images//Icon_Pil-ny.png'

class HjemmelsopplysningList extends Component {
    state = {
        hjemmelsopplysninger: [],
        isHjemmelsopplysningerLoaded: false,
        isLoading: false,
        isOpened: false
    }

    getHjemmelsopplysninger = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/hjemmelsopplysning/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                hjemmelsopplysninger: [...this.state.hjemmelsopplysninger, ...data.hjemmelsopplysninger],
                isHjemmelsopplysningerLoaded: true,
                isLoading: false})
        })
      }


    toggleHjemmelsopplysninger = () => {
        if (!this.state.isHjemmelsopplysningerLoaded) {
            this.getHjemmelsopplysninger()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleHjemmelsopplysninger}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={PilIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }                    
                    <span className="title">{t('hjemmelsopplysninger')} {this.state.isHjemmelsopplysningerLoaded && `(${this.state.hjemmelsopplysninger.length})`}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>                    
                </div>
                <div className={this.state.isOpened && this.state.hjemmelsopplysninger.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.hjemmelsopplysninger.map((h, index) => { return (<Hjemmelsopplysning key={h.dokumentnummer+h.dokumentnavn} hjemmelsopplysning={h} isLast={index==this.state.hjemmelsopplysninger.length-1} onEvent={this.props.onEvent} />)}) }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(HjemmelsopplysningList)